import { writable, get } from 'svelte/store';
import debounce from 'lodash/debounce';
import { loadWhispererSearch } from '../api/search.api';
export default class WhispererSearchService {
    constructor(dataProvider) {
        this._dataProvider = dataProvider;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this._whisperer = writable([]);
        this._displayWhisperer = writable(false);
        this.registerListeners();
    }
    registerListeners() {
        this._dataProvider.searchStringSubs.subscribe(debounce((searchString) => {
            if (searchString && searchString.length) {
                const searchParams = {
                    endpoint: this.dataProvider.whispererEndpoint,
                    query: searchString,
                    structureKeys: this.dataProvider.apiStructureKeys,
                    showSiteUrl: this.dataProvider.showSiteUrl,
                    groupId: this.dataProvider.groupId,
                };
                void loadWhispererSearch(searchParams)
                    .then((data) => {
                    this._whisperer.set(data);
                    this._displayWhisperer.set(true);
                });
            }
        }, 200));
    }
    set searchWhispererSubs(newValue) {
        this._displayWhisperer.set(newValue);
    }
    get searchWhispererSubs() {
        return this._displayWhisperer;
    }
    get whispererSubs() {
        return this._whisperer;
    }
    get whisperer() {
        return get(this._whisperer);
    }
    get dataProvider() {
        return this._dataProvider;
    }
}
